import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';

import { RouterStateUrl } from './router.state';

export const getRouterReducer = createFeatureSelector('routerReducer');

export const getRouterState = createSelector(getRouterReducer,
  (routerReducer: fromRouter.RouterReducerState<RouterStateUrl>) => routerReducer && routerReducer.state);

export const getQueryParams = createSelector(getRouterState, (state: RouterStateUrl) => state && state.queryParams);
export const getActiveUrl = createSelector(getRouterState, (state: RouterStateUrl) => state && state.url);

export const getActiveUrlWithoutParameters = createSelector(getRouterState,
  (state: RouterStateUrl) => {
  return state && state.url && state.url.split('?')[0];
  }
);
